// Decorative, GPU-only rising bubbles. aria-hidden, never intercepts pointer events.
// Very small element count; hidden on mobile and when prefers-reduced-motion is set (via CSS).
const BUBBLES = [
  { left: "3%", size: 10, dur: 13, delay: 0, lift: 320, drift: 8 },
  { left: "7%", size: 6, dur: 16, delay: 3, lift: 380, drift: -6 },
  { left: "11%", size: 8, dur: 14, delay: 6, lift: 300, drift: 5 },
  { right: "4%", size: 12, dur: 15, delay: 1.5, lift: 360, drift: -8 },
  { right: "9%", size: 7, dur: 17, delay: 5, lift: 340, drift: 6 },
  { right: "14%", size: 9, dur: 12, delay: 8, lift: 300, drift: -5 },
];

export default function Bubbles({ className = "" }) {
  return (
    <div className={`cf-bubbles hidden md:block ${className}`} aria-hidden="true">
      {BUBBLES.map((b, i) => (
        <span
          key={i}
          className="cf-bubble"
          style={{
            left: b.left,
            right: b.right,
            width: `${b.size}px`,
            height: `${b.size}px`,
            "--cf-dur": `${b.dur}s`,
            "--cf-delay": `${b.delay}s`,
            "--cf-lift": `${b.lift}px`,
            "--cf-drift": `${b.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
